import type { DpiaImpact, DpiaLikelihood, DpiaRiskLevel } from './dpias.types';

const LIKELIHOOD_SCORE: Record<DpiaLikelihood, number> = {
  unlikely: 1,
  possible: 2,
  likely: 3,
  very_likely: 4,
};

const IMPACT_SCORE: Record<DpiaImpact, number> = {
  limited: 1,
  significant: 2,
  serious: 3,
  very_serious: 4,
};

/** Mock-only helper until BE returns authoritative risk_level on risk updates. */
// eslint-disable-next-line import/prefer-default-export
export const calculateMockRiskLevel = (likelihood: DpiaLikelihood | '', impact: DpiaImpact | ''): DpiaRiskLevel | '' => {
  if (!likelihood || !impact) {
    return '';
  }

  const score = LIKELIHOOD_SCORE[likelihood] * IMPACT_SCORE[impact];

  if (score <= 4) {
    return 'low';
  }

  if (score <= 8) {
    return 'medium';
  }

  if (score <= 12) {
    return 'high';
  }

  return 'very_high';
};
